// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"M5-z","button":"N5-z","disabled":"O5-z","creditCard":"P5-z","wrapper":"Q5-z"};